import React, { useEffect, useState } from "react";
import styles from "./item-desc-modal.module.css";
import getImageFileName from "../../functions/getImageFileName";
import { STATUS_TYPE, CONSUME_TYPE, ITEM_REGION, JOURNEY_ITEM_TYPE, LOCALES } from "../../constants";
import { getUIText } from "../../translation";
import { loadData } from "../../functions/dataLoader";

export default function ItemDescModal({ lang, selected, isActive, setIsActive }) {
    const [buffs, setBuffs] = useState(null);

    useEffect(() => {
        loadData("journey_buffs.json").then(setBuffs);
    }, []);

    const getRarityClassName = (rarity) => {
        return rarity.replace("IG_", "").toLowerCase();
    };

    const getTypeClassName = (type) => {
        if (type === "NT_COOK") return "food";
        else if (type === "NT_TRAINING_EXP_ITEM") return "book";
        else if (type === "NT_CHARM") return "charm";
        return "valuables";
    };

    const getColoredSeText = (text) => {
        const regex = /<b><color=#(?<rgb>[0-9a-fA-F]{6})>/gm;
        const result = regex.exec(text);

        if (result) return text.replaceAll(regex, `<b style="color: #${result.groups.rgb};">`).replaceAll("</color>", "");
        return text;
    };

    if (!buffs) return;

    return (
        <div
            className={`modal items ${isActive ? "active" : ""}`}
            onClick={(e) => {
                if (e.target.classList.contains("modal")) setIsActive(false);
            }}
        >
            <div className="window">
                <button className="close-button" onClick={() => setIsActive(false)}>
                    <i className="fi fi-sr-x" />
                </button>

                <div className={styles["item-wrapper"]}>
                    <div className={`${styles["item-image"]} ${styles[getRarityClassName(selected.rarity)]}`}>
                        <img src={`${process.env.PUBLIC_URL}/images/item/${getImageFileName(selected.name[LOCALES.KO])}.webp`} />
                    </div>
                    <div className={styles["item-info"]}>
                        <div className={styles["item-header"]}>
                            <div className={`${styles["item-image"]} ${styles["small"]} ${styles[getRarityClassName(selected.rarity)]}`}>
                                <img src={`${process.env.PUBLIC_URL}/images/item/${getImageFileName(selected.name[LOCALES.KO])}.webp`} />
                            </div>
                            <div className={styles["item-summary"]}>
                                <div className={styles["item-name"]}>{selected.name[lang]}</div>
                                <div className={styles["badges"]}>
                                    <div className={`${styles["badge"]} ${styles[getTypeClassName(selected.type)]}`}>
                                        {JOURNEY_ITEM_TYPE[selected.type][lang]}
                                    </div>
                                    {selected.charm_info && (
                                        <div className={`${styles["badge"]} ${styles["pp"]}`}>
                                            {getUIText(lang, "item.modal.badge.potentialPoint")} {selected.charm_info.pp}
                                        </div>
                                    )}
                                    {selected.req_coin && (
                                        <div className={`${styles["badge"]} ${styles["price"]}`}>
                                            {getUIText(lang, "item.modal.badge.price")} {selected.req_coin}
                                        </div>
                                    )}
                                    {selected.charm_info && selected.charm_info.target && (
                                        <div className={`${styles["badge"]} ${styles["target"]}`}>{selected.charm_info.target}</div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className={styles["description-wrapper"]}>
                            <div className={styles["title"]}>{getUIText(lang, "item.modal.desc.title")}</div>
                            <div className={styles["description"]}>{selected.description[lang]}</div>
                        </div>
                        <div className={styles["description-wrapper"]}>
                            <div className={styles["title"]}>{getUIText(lang, "item.modal.effect.title")}</div>
                            {selected.type === "NT_CHARM" && selected.charm_info.se_list.length !== 0 && (
                                <div
                                    className={styles["description"]}
                                    dangerouslySetInnerHTML={{ __html: getColoredSeText(selected.charm_info.se_list[0][lang]) }}
                                ></div>
                            )}
                            {selected.type === "NT_CHARM" && selected.charm_info.stat_type && (
                                <div className={styles["description"]}>
                                    {STATUS_TYPE[selected.charm_info.stat_type][lang]} +{selected.charm_info.stat_value}
                                </div>
                            )}
                            {selected.type === "NT_TRAINING_EXP_ITEM" && (
                                <div className={styles["description"]}>
                                    {CONSUME_TYPE[selected.stats[0].type][lang]} +{selected.stats[0].value}
                                </div>
                            )}
                            {selected.type === "NT_COOK" &&
                                selected.stats.map((stat) => {
                                    if (stat.type === "UT_BUFF_ADD") {
                                        const buff = buffs.find((e) => e.id === stat.value);

                                        return (
                                            <div className={`${styles["description"]} ${styles["buff"]}`}>
                                                <div className={styles["row"]}>
                                                    {CONSUME_TYPE[stat.type][lang]}{" "}
                                                    <img src={`${process.env.PUBLIC_URL}/images/icon/journey_buff/${buff.icon}`} />
                                                    {buff.name[lang]}
                                                </div>
                                                <div className={styles["row"]}>
                                                    <img src={`${process.env.PUBLIC_URL}/images/icon/journey_buff/${buff.icon}`} />{" "}
                                                    {buff.name[lang]} : {buff.desc[lang]}
                                                </div>
                                            </div>
                                        );
                                    } else if (stat.type === "UT_BUFF_DELETE_NEGATIVE") {
                                        return <div className={styles["description"]}>{CONSUME_TYPE[stat.type][lang]}</div>;
                                    } else if (typeof stat.min_value === "number") {
                                        return (
                                            <div className={styles["description"]}>
                                                {CONSUME_TYPE[stat.type][lang]} +{stat.min_value} ~ {stat.max_value}
                                            </div>
                                        );
                                    }

                                    return (
                                        <div className={styles["description"]}>
                                            {CONSUME_TYPE[stat.type][lang]} +{stat.value}
                                        </div>
                                    );
                                })}
                            {selected.type === "NT_VALUABLES" && (
                                <div className={styles["description"]}>
                                    {selected.name[LOCALES.KO] === "활력 포션"
                                        ? lang === LOCALES.KO
                                            ? "훈련 실패 이벤트에서 사용"
                                            : "Use Training Failed Event"
                                        : "-"}
                                </div>
                            )}
                        </div>
                        <div className={styles["description-wrapper"]}>
                            <div className={styles["title"]}>{getUIText(lang, "item.modal.source.title")}</div>
                            {selected.events &&
                                selected.events.map((event, index) => {
                                    return (
                                        <div className={styles["description"]} key={`event_${index}`}>
                                            {event[lang]}
                                        </div>
                                    );
                                })}
                            {selected.regions && (
                                <div className={styles["description"]}>
                                    {getUIText(lang, "item.modal.source.shop")}(
                                    {selected.regions.map((e) => ITEM_REGION[e][lang]).join(", ")})
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
